import { Moon02Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Moon = /* @__PURE__ */ createIcon(Moon02Icon, 'Moon');
